<template>
  <b-modal id="suggest_invest" centered ref="suggest_invest">
    <h3>Hi, {{ user.firstname }}</h3>
    <p>
      Congratulations, your wallet balance can afford you
      {{ Math.floor(balance / 50000) }} units of investment
    </p>
  </b-modal>
</template>

<script>
export default {
  props: {
    user: null,
    balance: null
  }
};
</script>

<style></style>
